import * as React from 'react'
// libs
import { useQuery } from '@apollo/client/react'
// context
import { TableManagementContext } from 'containers/Search/layers/BL'
// graphql
import { PLAN_TYPES_LIST_QUERY } from 'graphql/planType/queries'
// types
import { IPlanType } from 'types/graphql'
import { NGetPlanTypes } from 'types/plan-type/helpers'
import { TRefetch } from 'types/refetch'
// utils
import get from 'lodash/get'

type Props = React.PropsWithChildren<unknown>

type QueryResponse = {
  planTypes: NGetPlanTypes.IResponse
}

interface IContext {
  data: IPlanType[]
  refetch: TRefetch<QueryResponse, NGetPlanTypes.IVariables>
  isLoading: boolean
  totalCount: number
  isRefetching: boolean
}

export const PlanTypesPageContext = React.createContext<IContext>({} as any)

const PlanTypesPageAPI: React.FC<Props> = ({ children }) => {
  const { page, perPage } = React.useContext(TableManagementContext)

  const { data, networkStatus, refetch } = useQuery<QueryResponse>(PLAN_TYPES_LIST_QUERY, {
    variables: {
      pagination: {
        pageSkip: page * perPage,
        pageTake: perPage
      }
    }
  })

  const planTypes = get(data, 'planTypes.data', [])
  const totalCount = get(data, 'planTypes.pagination.totalCount')

  const value = {
    refetch,
    totalCount,
    data: planTypes,
    isLoading: networkStatus === 1,
    isRefetching: networkStatus === 2
  }

  return <PlanTypesPageContext.Provider value={value}>{children}</PlanTypesPageContext.Provider>
}

export default PlanTypesPageAPI
